import { Section } from "../section";
import { DownloadImageCard } from "../../download/download";

export function DownloadSection(props) {
    return <Section title="Downloads">
        <DownloadImageCard />
    </Section>
}